import { useSelector } from 'react-redux';

import { formatNumberAndCents } from '@makemydeal/dr-common-utils';
import { CASH_DUE_TODAY } from '@makemydeal/dr-dash-components';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

import { ReadOnlyValueRow } from '../../ReadOnlyValueRow';

export const CashDueTodayRow = () => {
    const cashDueToday = useSelector(offerReduxSelectors.getCashDueFromCustomer);

    return (
        <ReadOnlyValueRow
            rowKey="cashDueToday"
            label={CASH_DUE_TODAY}
            value={`$${formatNumberAndCents(cashDueToday)}`}
            valueTestId="cash-due-today-summary-readonly-value"
        />
    );
};
